module.exports = __webpack_public_path__ + "img/undertakingCases9.4f94cb08.jpg";